import React, { useState, useMemo } from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router';
import ReactSelect from '../../components/Inputs/ReactSelect';
import { TREATMENT_TYPES } from '../../helpers/enum';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useUsers from '../../store/users/usersContext';
import useClinics from '../../store/clinics/clinicsContext';
import useTreatments from '../../store/treatments/treatmentsContext';
import useApp from '../../store/app/appContext';

function AddTreatment() {
  
  const history = useHistory();

  const { appState: { user, userAccount }} = useApp();

  const {
    getAllPatients,
  } = useUsers();

  const {
    getAllClinics,
    getPartnerClinics
  } = useClinics();

  const { createTreatment, partnerCreateTreatment } = useTreatments();

  const [patients, setPatients] = useState([]);
  const [clinics, setClinics] = useState([])

  React.useEffect(() => {
    getAllPatients().then(res => setPatients(res?.data || []));
    if (userAccount.isAdmin) getAllClinics().then(res => setClinics(res || []));
    if (userAccount.isPartner) getPartnerClinics(user._id).then(res => {
      setClinics(res || [])});
    
  }, []);

  const [ newTreatment, _setNewTreatment ] = React.useState({
    patientId: null,
    patientName: null,
    treatmentType: null,
    clinicId: null,
    clinicName: null,
  });

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const setNewTreatment = (newVal) => _setNewTreatment({...newTreatment, ...newVal});
  
  const selectPatientOptions = useMemo(() => {
    const _patients = [];
    if (patients.length) patients.forEach(patient => _patients.push({label: patient.first_name + ' ' + patient.last_name, value: patient._id}));
    return _patients
  }, [patients]);
  
  const selectClinicOptions = useMemo(() => {
    let _clinics = [];
    if (clinics.length) clinics.forEach(center => _clinics.push({label: center.name, value: center._id}));
    return _clinics
  }, [clinics]);
  
  const treatmentTypeOptions = [];
  if (!treatmentTypeOptions.length) TREATMENT_TYPES.map(type => (
    treatmentTypeOptions.push({
      label: type,
      value: type
    })
  ));

  const handleCreate = () => {
    let element;
    if (!newTreatment.patientName) {
      element = document.getElementById('patientName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'patientName',
        msg: "Please select a patient."
      });
    }
    if (!newTreatment.treatmentType) {
      element = document.getElementById('treatmentType');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'treatmentType',
        msg: "Please select a treatment type."
      });
    }
    if (!newTreatment.clinicName) {
      element = document.getElementById('clinicName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'clinicName',
        msg: "Please select a clinic."
      });
    }
    const { clinicId, patientId, treatmentType } = newTreatment;
    const dataToSend = { clinicId, patientId, treatmentType };
    if (userAccount.isAdmin) createTreatment(dataToSend).then(res => {
      history.goBack();
    })
    if (userAccount.isPartner) partnerCreateTreatment(dataToSend).then(res => {
      history.goBack();
    })
  }
  
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Treatment information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4 '>
          <ReactSelect id='patientName' label='Patient*' options={selectPatientOptions} value={newTreatment.patientName} inputClass='col-span-3' onChange={(e) => setNewTreatment({patientName: e.label, patientId: e.value})} /> 
          {formError.field === 'patientName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <ReactSelect 
            id='treatmentType' 
            label='Treatment type*' 
            inputClass='col-span-3' 
            options={treatmentTypeOptions} 
            value={newTreatment.treatmentType}
            onChange={(e) => setNewTreatment({treatmentType: e.label})}
          /> 
          {formError.field === 'treatmentType' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className="bg-white rounded shadow py-12 px-10 mt-6">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Clinic details</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4'>  
           <ReactSelect 
            id='clinicName' 
            label='Clinic*'
            inputClass='col-span-3' 
            options={selectClinicOptions} 
            value={newTreatment.clinicName}
            onChange={(e) => setNewTreatment({clinicName: e.label, clinicId: e.value})}
          /> 
          {formError.field === 'clinicName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' onClick={() => history.push('/manage-treatments')} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddTreatment